import src from "IMAGE";
export default { src, width: 73, height: 73, blurWidth: 0, blurHeight: 0};
